import React from 'react'
import { Button as BsButton, Form } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'
import { createHeaderRow, type HeaderRow } from '../form/customIntegrationForm'

interface HeadersFormFieldsProps {
  headers: HeaderRow[]
  onChange: (headers: HeaderRow[]) => void
  disabled?: boolean
}

export const HeadersFormFields: React.FC<HeadersFormFieldsProps> = ({ headers, onChange, disabled = false }) => {
  const updateRow = (id: string, patch: Partial<HeaderRow>) => onChange(headers.map((row) => (row.id === id ? { ...row, ...patch } : row)))

  return (
    <div className='d-flex flex-column gap-3'>
      <div className='d-flex flex-column zocks-gap-0.25'>
        <span className='paragraph-medium fw-600 zocks-text-gray-900'>Custom headers (optional)</span>
        <span className='paragraph-small zocks-text-gray-600'>Extra headers for identity request</span>
      </div>
      {headers.map((row, index) => (
        <div key={row.id} className='d-flex align-items-end gap-3'>
          <Form.Group className='flex-grow-1' controlId={`custom-integration-header-name-${row.id}`}>
            <Form.Label className='paragraph-small mb-1'>Header name</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter header name'
              value={row.name}
              disabled={disabled}
              isInvalid={row.name.trim() === '' && row.value.trim() !== ''}
              onChange={(e) => updateRow(row.id, { name: e.target.value })}
            />
          </Form.Group>
          <Form.Group className='flex-grow-1' controlId={`custom-integration-header-value-${row.id}`}>
            <Form.Label className='paragraph-small mb-1'>Value</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter value'
              value={row.value}
              disabled={disabled}
              onChange={(e) => updateRow(row.id, { value: e.target.value })}
            />
          </Form.Group>
          {headers.length > 1 && !disabled ? (
            <BsButton variant='outline-secondary' aria-label={`Remove header ${index + 1}`} onClick={() => onChange(headers.filter((r) => r.id !== row.id))}>
              <i className='bi bi-x-lg' />
            </BsButton>
          ) : null}
        </div>
      ))}
      {disabled ? null : (
        <Button
          type='button'
          variant='primaryLinkButton'
          className='align-self-start d-flex align-items-center gap-1 text-decoration-none'
          onClick={() => onChange([...headers, createHeaderRow()])}
        >
          <i className='bi bi-plus-circle' />
          Add Header
        </Button>
      )}
    </div>
  )
}
